import { HiOutlineOfficeBuilding } from "react-icons/hi";
import { BuildingType, TP_Building } from "./types";
import { LuHotel, LuSchool2, LuBuilding, LuStore } from "react-icons/lu"
import { FaRegHospital } from "react-icons/fa";
import { TbBuildingEstate } from "react-icons/tb";

const Icon = (props: any) => {

    switch (props.type) {
        case BuildingType.Office:
            return <LuBuilding color={props.color} size={props.size} />;
        case BuildingType.Hotel:
            return <LuHotel color={props.color} size={props.size} />;;
        case BuildingType.Educational:
            return <LuSchool2 color={props.color} size={props.size} />;
        case BuildingType.ShoppingMall:
            return <LuStore color={props.color} size={props.size} />;
        case BuildingType.Hospital:
            return <FaRegHospital color={props.color} size={props.size} />;
        case BuildingType.Living:
            return <TbBuildingEstate color={props.color} size={props.size} />;

        default:
            return <HiOutlineOfficeBuilding color={props.color} size={props.size} />;
    }


}

export default Icon;